import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { AddBankAccount, AddBankAccountRoutingNumber } from 'app/signup/features/data/data.actions';
import { ToastService } from 'app/toast/services/toast.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-account-routing-number',
  templateUrl: './account-routing-number.component.html',
  styleUrls: ['./account-routing-number.component.scss']
})
export class AccountRoutingNumberComponent implements OnInit {
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public form: UntypedFormGroup = new UntypedFormGroup({
    'country': new UntypedFormControl('US', []),
    'currency': new UntypedFormControl('USD', []),
    'routing_number': new UntypedFormControl('', [Validators.required, Validators.pattern("[0-9]+")]),
    'account_number': new UntypedFormControl('', [Validators.required, Validators.pattern("[0-9]+")])
  });

  constructor(
    private store: Store,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);

    const { initialState: { action, callback } } = dialog;
    if(value) {
      if(action) {
        this.store.dispatch(action);
      }
      callback(value);
    }
  }

  confirm(dialog, value) {
    const { form } = this;

    if (form.invalid) {
      form.markAllAsTouched();
      return;
    }

    if(!window['Stripe'].bankAccount.validateRoutingNumber(form.value.routing_number, 'US')) {
      form.get('routing_number').setErrors({ stripe: true });
      form.markAllAsTouched();
      this.cdr.markForCheck();
      return;
    }
    if(!window['Stripe'].bankAccount.validateAccountNumber(form.value.account_number, 'US')) {
      form.get('account_number').setErrors({ stripe: true });
      form.markAllAsTouched();
      return;
    }

    window['Stripe'].setPublishableKey(window['api'].getStripePublishableKey());
    window['Stripe'].bankAccount.createToken(form.value, (status, response) => {
      if (response.error) {
        const { error } = response;
        if(error.code === 'routing_number_invalid') {
          form.get('account_number').setErrors({ stripe: true });
          form.markAllAsTouched();
          this.cdr.markForCheck();
          return;
        }
        if(error.code === 'account_number_invalid') {
          form.get('account_number').setErrors({ stripe: true });
          form.markAllAsTouched();
          this.cdr.markForCheck();
          return;
        }
        form.setErrors({ stripe: true });
        form.markAllAsTouched();
        this.cdr.markForCheck();
        return;
      }
      this.store.dispatch({
        type: AddBankAccountRoutingNumber.type,
        payload: {
          bankAccountToken: response.id,
        }
      });
      this.close(dialog, value);
    });
  }

  getRoutingNumber() {
    const { form } = this;
    const routing_number = form.get('routing_number');

    if (!routing_number.touched) return '';

    if (form.hasError('stripe')) {
      return 'Incorrect Routing Number or Account Number';
    }

    if (routing_number.hasError('required')) {
      return 'Please provide Routing Number';
    }

    if (routing_number.hasError('stripe')) {
      return 'Incorrect Routing Number';
    }

    if (routing_number.hasError('pattern')) {
      return 'Routing Number can contains only digits';
    }

    return '';
  }

  getAccountNumber() {
    const { form } = this;
    const account_number = form.get('account_number');

    if (!account_number.touched) return '';

    if (form.hasError('stripe')) {
      return 'Incorrect Routing Number or Account Number';
    }

    if (account_number.hasError('required')) {
      return 'Please provide Account Number';
    }

    if (account_number.hasError('stripe')) {
      return 'Incorrect Account Number';
    }

    if (account_number.hasError('pattern')) {
      return 'Account Number can contains only digits';
    }

    return '';
  }
}
